import * as api from './api'
import { computed, ref } from 'vue'
import { GetRolesResponse } from '@/modules/acl/api'

const roles = ref<GetRolesResponse>([])

const getRoles = () => api.getRoles().then(rolesList => {
    roles.value = rolesList
})

export function useAclModule () {
    return {
        getRoles,
        roles: computed(() => roles.value),
        updateMemberRole: api.updateSingleMemberRole,
        deleteMemberRole: api.deleteSingleMemberRole
    }
}
